<script lang="ts">
  import { createEventDispatcher } from "svelte";
  export let open = false;
  export let value: { key: string; display: string };
  export let data: (typeof value)[];
  export let placeholder: string | undefined;
  export let label: string | undefined;
  let inputEl: Element;
  const dispatch = createEventDispatcher();
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
  class="input-cell input"
  bind:this={inputEl}
  on:click={() => {
    open = !open;
  }}
  on:click
  class:open
>
  <div class="input-flex-wrapper">
    <div>
      <div class="label">
        {label ?? " "}
      </div>
      <div class="value" class:hasLabel={label}>{@html value?.display ?? placeholder}</div>
    </div>
    <svg width="13" height="8" viewBox="0 0 13 8" fill="none">
      <path d="M12 1L6.5 6L1 1" stroke="black" stroke-width="2" />
    </svg>
  </div>

  {#if open}
    <div class="dropdown">
      {#each data as x, i}
        {@const selected = x.key === value?.key}
        <div
          class="option input-cell"
          on:click={() => {
            if (selected) return;
            dispatch("optionClick", x.key);
          }}
          class:selected
        >
          {@html x.display}
        </div>
      {/each}
    </div>
  {/if}
</div>
<svelte:window
  on:click={({ target }) => {
    if (target === null) {
      if (open && inputEl && !inputEl.contains(target)) {
        open = false;
      }
    }
  }}
/>

<style>
  .input {
    box-sizing: border-box;

    border: solid 1px #dbdbdb;
    width: 100%;

    position: relative;
    font-size: 14px;
    border-bottom: 2px #fcba12 solid;
  }
  .label {
    font-size: 10px;
    line-height: 10px;
  }
  .value {
    line-height: 14px;
    margin-top: 6px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
  .value.hasLabel {
    margin-top: 0px;
  }
  .open {
    z-index: 50;
  }
  .input-cell {
    height: 38px;
    padding: 4px 12px;
    background: white;
  }
  .option {
    /* 					outline:blue solid thin;
   */
    padding: 0 38px; /*reset padding*/
    line-height: 38px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
  .selected {
    background: #eee;
  }
  .option:hover {
    background: #eee;
  }
  .dropdown {
    position: absolute;
    width: 100%;
    background: white;
    bottom: -2px;
    left: -1px;
    transform: translateY(100%);
    padding: 14px 0 18px 0px;
    border: solid 1px #979797;
    box-sizing: border-box;
  }
  .input-flex-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  @media (max-width: 767px) {
    .input {
      display: block;
      width: 100%;
      /* max-width: 350px; */
    }
    .dropdown {
      width: 100%;
    }
    .option {
      height: 48px;
      line-height: 48px;
    }
  }
</style>
